enum GatewayBatteryConstants {
  UNDEFINED = 'UNDEFINED',
  CRITICAL = 'CRITICAL',
  LOW = 'LOW',
  HALF = 'HALF',
  HIGH = 'HIGH',
  FULL = 'FULL',
}

export default GatewayBatteryConstants;
